<template>
  <div
    class="mobile-header d-flex flex-row align-items-center justify-content-space-between i-p-16"
  >
    <logo-component :is-mobile="false" :color="'#39075B'" height="21px" />
    <i-button
      class="remove"
      aria-label="Mobile header: Toggle navigation menu"
      data-dd-action-name="mobile-header-toggle-nav"
      :left-icon="'medium-hamburger'"
      :type="iButtonTypes.NEUTRAL"
      :button-style="iButtonStyles.GHOST"
      @button-click="toggleLeftNav()"
    ></i-button>
  </div>
</template>

<script>
import LogoComponent from '../Logo';
import palette from '@inscribe/signal/dist/palette';
import { iButton, iButtonStyles, iButtonTypes } from '@inscribe/signal';

export default {
  components: { iButton, LogoComponent },
  props: {},
  data: () => ({
    menuOpen: false,
    palette,
    iButtonStyles,
    iButtonTypes,
  }),
  computed: {},
  methods: {
    toggleLeftNav() {
      this.$emit('toggle-left-nav');
    },
  },
};
</script>

<style lang="scss" scoped>
.mobile-header {
  background: $light-neutral-default;
  height: 56px;
  width: 100%;
  justify-content: space-between;
}
</style>
